"use client"

import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
} from "@mui/material"
import { TrendingDown } from "lucide-react"

const textColor = "#0d2561"
const itextColor = "#707070"

export function RatesWidget() {
  const fallThroughRates = [
    { area: "Phoenix, AZ", rate: "15%" },
    { area: "Los Angeles, CA", rate: "18%" },
    { area: "Miami, FL", rate: "12%" },
    { area: "Dallas, TX", rate: "10%" },
  ]

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1, fontSize:'1.20rem' }}>
          Rates
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Most fall-through rates by Metropolitan areas.
        </Typography>

        <Stack spacing={2} mb={24}>
          {fallThroughRates.map((item, index) => (
            <Box key={index}>
              <Typography variant="body1" sx={{ fontWeight: 500, color: textColor }}>
                {item.area}
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <TrendingDown className="h-3 w-3" color="#ef4444" width='14px' height='14px' />
                <Typography variant="body2" sx={{ color: itextColor }}>
                  Fall-through rate: {item.rate}
                </Typography>
              </Stack>
            </Box>
          ))}
        </Stack>
      </CardContent>
    </Card>
  )
}
